import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-message-input',
  templateUrl: './message-input.component.html',
  styleUrls: ['./message-input.component.scss']
})
export class MessageInputComponent implements OnInit {
  @Input() mobileNo: string;  // Accept MobileNo as an input
  @Output() messageSent = new EventEmitter<void>();  // Emit event when a message is sent

  messageForm!: FormGroup;
  baseUrl: string = environment.baseUrl;

  constructor(private fb: FormBuilder, private http: HttpClient) {}

  ngOnInit(): void {
    this.messageForm = this.fb.group({
      messageType: ['Text', Validators.required],
      textMessage: [''],
      templateName: [''],
      imageUrl: ['']
    });

    // Update form controls when the message type changes
    this.messageForm.get('messageType').valueChanges.subscribe(value => {
      this.updateFormControls(value);
    });
  }

  updateFormControls(messageType: string) {
    if (messageType === 'Text') {
      this.messageForm.get('textMessage').setValidators([Validators.required]);
      this.messageForm.get('templateName').clearValidators();
      this.messageForm.get('imageUrl').clearValidators();
    } else if (messageType === 'ImageTemplate') {
      this.messageForm.get('textMessage').clearValidators();
      this.messageForm.get('templateName').setValidators([Validators.required]);
      this.messageForm.get('imageUrl').setValidators([Validators.required]);
    } else if (messageType === 'Template') {
      this.messageForm.get('textMessage').clearValidators();
      this.messageForm.get('templateName').setValidators([Validators.required]);
      this.messageForm.get('imageUrl').clearValidators();
    }

    this.messageForm.get('textMessage').updateValueAndValidity();
    this.messageForm.get('templateName').updateValueAndValidity();
    this.messageForm.get('imageUrl').updateValueAndValidity();
  }

  onSendMessage() {
    if (this.messageForm.invalid) {
      return;
    }

    const formValues = this.messageForm.value;
    let apiUrl: string = '';
    let params = new HttpParams().set('to', this.mobileNo);

    if (formValues.messageType === 'Text') {
      params = params.set('message', formValues.textMessage);
      apiUrl = this.baseUrl + 'whatsapp/send-text-message';
    } else if (formValues.messageType === 'ImageTemplate') {
      params = params.set('templateName', formValues.templateName)
                     .set('imageUrl', formValues.imageUrl);
      apiUrl = this.baseUrl + 'whatsapp/send-template-with-header-image';
    } else if (formValues.messageType === 'Template') {
      params = params.set('templateName', formValues.templateName);
      apiUrl = this.baseUrl + 'whatsapp/send-template';
    }

    this.http.post(apiUrl, null, { params }).subscribe(response => {
      console.log('Message sent:', response);
      this.messageSent.emit();  // Emit event to refresh conversation data
      this.resetForm();  // Reset the form
    }, error => {
      console.error('Error sending message:', error);
    });
  }

  resetForm() {
    this.messageForm.reset({
      messageType: 'Text'  // Reset the form and keep the default value for messageType
    });
  }
}
